import React from "react";
import { isDirect } from "src/utils/userSegment";
import FooterLanding from "./FooterLanding";
import FooterLandingSmall from "./FooterLandingSmall";
import {
  ResultsVaryDisclaimer,
  useShowDisclaimer,
} from "../results-vary-disclaimer/ResultsVaryDisclaimer";

export function LandingFooter() {
  const showDisclaimer = useShowDisclaimer();
  const direct = isDirect();

  return (
    <>
      {direct ? <FooterLanding /> : <FooterLandingSmall />}
      {showDisclaimer && <ResultsVaryDisclaimer />}
    </>
  );
}
